[
  {
    "id": "POLICARBONATO_ALVEOLAR",
    "descriptions": {
      "title": "Chapa de Policarbonato: Versatilidade, Beleza e Resistência para Seus Projetos",
      "sections": [
        {
          "subtitle": "Chapas de Policarbonato: Amplie Suas Opções em Arquitetura e Design",
          "text": "Com as chapas de policarbonato, projetos de diferentes estilos ganham soluções transparentes e translúcidas, seja para ambientes internos ou externos. O material pode ser encontrado em diversas cores e acabamentos, permitindo total integração com propostas modernas ou clássicas. Além disso, a facilidade de instalação, a flexibilidade e a baixa necessidade de manutenção tornam o produto ideal para quem busca praticidade sem abrir mão da longevidade. Salas, varandas, entradas e até mesmo áreas industriais podem ser beneficiadas por essa tecnologia."
        },
        {
          "subtitle": "Chapa de Policarbonato Transparente: Iluminação Natural sem Comprometer a Segurança",
          "text": "A chapa de policarbonato transparente é reconhecida por permitir a passagem de luz natural, tornando os ambientes mais agradáveis e econômicos no gasto com energia elétrica. Essa característica é fundamental em coberturas, estufas, claraboias e passarelas, promovendo luminosidade com proteção contra impactos, intempéries e raios UV. Sua transparência não compromete a privacidade e oferece uma estética contemporânea, valorizando o visual do espaço com um acabamento limpo e elegante."
        },
        {
          "subtitle": "Chapa de Policarbonato Alveolar: Leveza e Isolamento em um Só Material",
          "text": "Para quem prioriza leveza e isolamento térmico, a chapa de policarbonato alveolar merece destaque. Sua estrutura interna com “alvéolos” ajuda a reduzir a transferência de calor, tornando o ambiente mais confortável mesmo sob altas temperaturas. Além do excelente desempenho construtivo, essa chapa apresenta ótimo custo-benefício, pois reduz gastos tanto na instalação quanto na manutenção ao longo do tempo."
        },
        {
          "subtitle": "Chapa de Policarbonato Alveolar Cristal: Transparência e Sofisticação",
          "text": "A escolha pela chapa de policarbonato alveolar cristal garante máxima transmissão de luz enquanto oferece leveza e modernidade à sua cobertura. Seu visual limpo e brilho sofisticado proporcionam resultados harmônicos e valorizam qualquer ambiente, seja na casa, empresa ou espaço de lazer."
        },
        {
          "subtitle": "Alveolar Policarbonato e Policarbonato Alveolar: Funcionalidade e Durabilidade",
          "text": "Ao optar pelo alveolar policarbonato ou policarbonato alveolar, você investe em um produto que alia praticidade, resistência a impactos e ótimo desempenho térmico. Esses materiais têm grande aceitação no mercado, sendo empregados em obras com diferentes dimensões e necessidades — desde pequenas soluções residenciais até grandes galpões industriais."
        },
        {
          "subtitle": "Conte com a RM Policarbonatos",
          "text": "Para resultados ainda mais eficientes, conte com materiais originais, garantia de fábrica e um fornecedor com experiência consolidada no setor, como a RM Policarbonatos. Nosso portfólio reúne opções em diversos acabamentos, tamanhos e espessuras, adequando-se a cada projeto."
        },
        {
          "subtitle": "Diferenciais das Chapas de Policarbonato",
          "text": "Diferente de materiais tradicionais, as chapas de policarbonato proporcionam facilidade na personalização, liberdade para criar ambientes modernos e seguros, além de oferecerem excelente relação entre custo e benefício. Ao escolher a RM Policarbonatos, você conta com atendimento especializado, ampla variedade de produtos e compromisso real com a satisfação do seu projeto."
        }
      ]
    }
  },
  {
    "id": "TOLDO_EM_POLICARBONATO",
    "descriptions": {
      "title": "Toldo em Policarbonato: Modernidade e Praticidade para seus Ambientes",
      "sections": [
        {
          "subtitle": "Toldos em Policarbonato: Versatilidade e Estilo para Diversos Ambientes",
          "text": "A aplicação de toldos em policarbonato se destaca principalmente pela variedade de modelos e estilos..."
        },
        {
          "subtitle": "Toldo em Policarbonato Alveolar: Proteção Térmica e Design Sofisticado",
          "text": "O modelo alveolar é indicado especialmente para quem busca não apenas proteção, mas também conforto térmico..."
        },
        {
          "subtitle": "Toldo Fixo em Policarbonato: Durabilidade e Facilidade de Manutenção",
          "text": "A principal característica do toldo fixo em policarbonato é a grande resistência e a baixa necessidade de manutenção..."
        },
        {
          "subtitle": "Compromisso com Qualidade",
          "text": "Aqui na RM Policarbonatos, você terá acesso a materiais de altíssima qualidade..."
        },
        {
          "subtitle": "Complementos Recomendados",
          "text": "Não deixe de conferir nossas categorias de policarbonato compacto e toldos cortina..."
        },
        {
          "subtitle": "Por que escolher a RM Policarbonatos?",
          "text": "Oferecemos diferenciais como atendimento personalizado, garantia estendida e entrega ágil em todo o Brasil..."
        }
      ]
    }
  },
  {
    "id": "POLICARBONATO_COMPACTO_KIT",
    "descriptions": {
      "title": "Chapa Policarbonato Compacta: Versatilidade e Resistência em Diferentes Ambientes",
      "sections": [
        {
          "subtitle": "Policarbonato Compacto 3mm: Leveza para Estruturas Sofisticadas",
          "text": "O policarbonato compacto 3mm se mostra ideal para quem precisa de uma superfície leve..."
        },
        {
          "subtitle": "Policarbonato Compacto Cristal: Transparência e Elegância",
          "text": "O policarbonato compacto cristal se destaca por sua impressionante transparência..."
        },
        {
          "subtitle": "Policarbonato Compacto Fumê: Estilo e Conforto Térmico",
          "text": "O policarbonato compacto fumê é a preferência de quem busca sofisticação e proteção extra contra o calor..."
        },
        {
          "subtitle": "Vantagens do Policarbonato Compacto",
          "text": "Entre os principais benefícios da chapa policarbonato compacta, destacam-se a excelente resistência ao impacto..."
        },
        {
          "subtitle": "Soluções Completas para Seu Projeto",
          "text": "Se você busca alternativas modernas e eficientes, não deixe de conferir as categorias de policarbonato compacto e toldos cortina..."
        }
      ]
    }
  },
  {
    "id": "ROMANA",
    "descriptions": {
      "title": "Persiana Romana Blackout: Elegância e Praticidade para Cada Ambiente",
      "sections": [
        {
          "subtitle": "Persiana Romana: Design e Versatilidade",
          "text": "A persiana romana é uma excelente escolha para quem deseja unir estilo contemporâneo à flexibilidade de uso..."
        },
        {
          "subtitle": "Cortina Persiana Romana: Funcionalidade e Conforto",
          "text": "Ao investir em uma cortina persiana romana, você conquista mais do que beleza..."
        },
        {
          "subtitle": "Persiana Romana Quarto: Bem-estar e Privacidade Garantidos",
          "text": "Entre as áreas da casa, o quarto merece atenção especial. A persiana romana quarto é um destaque por garantir noites mais tranquilas..."
        },
        {
          "subtitle": "Diferenciais e Benefícios",
          "text": "A persiana romana blackout oferece proteção eficiente contra raios UV, ajudando a preservar móveis e objetos de decoração..."
        },
        {
          "subtitle": "Por que escolher persiana romana blackout?",
          "text": "Além de valorizar o ambiente, este tipo de persiana proporciona controle total da luminosidade..."
        }
      ]
    }
  }
]